import { EXPERIENCE_FORM_REGISTRY as BASE_FORM_REGISTRY } from './writable-form-registry.js';
const BASE_IMPORT_FORM_ID = 'form.importJob.create';
const base = BASE_FORM_REGISTRY[BASE_IMPORT_FORM_ID];
if (!base) {
    throw new Error(`Missing canonical import form: ${BASE_IMPORT_FORM_ID}`);
}
/**
 * Effective import projection over the governed import lifecycle. Every value
 * below is implemented by the API validator and commit strategy registry; the
 * browser must not invent aliases or advertise unsupported domains.
 */
export const IMPORT_JOB_CREATE_FORM = Object.freeze({
    ...base,
    fields: base.fields.map((field) => field.name === 'importType'
        ? {
            ...field,
            options: [
                { value: 'INSTRUMENT', labelKey: 'importJob.type.instrument' },
                { value: 'TRANSACTION', labelKey: 'importJob.type.transaction' },
                { value: 'MARKET_DATA', labelKey: 'importJob.type.marketData' },
                { value: 'CORPORATE_ACTION', labelKey: 'importJob.type.corporateAction' },
                { value: 'CUSTODY_POSITION', labelKey: 'importJob.type.custodyPosition' },
                { value: 'OPENING_CUTOVER', labelKey: 'importJob.type.openingCutover' },
                { value: 'TAX_RULE', labelKey: 'importJob.type.taxRule' },
            ],
        }
        : field),
});
